import React, { useEffect, useState } from "react";
import SetRatingStars from "../../helpers/setRatingStars";
import { apiURL } from "../../helpers/url";

const RatingBook = (props) => {
    const [rating, setRating] = useState(props.Rating);
    const [review, setReview] = useState("");

    const closeModal = () => {
        const ratingModal = document.getElementById("ratingModal");
        ratingModal.classList.add("hidden");
        props.onClose?.();
    };

    async function handleSave() {
        await props.handleRating({ rate: rating, review: review });
        closeModal();
        $("#commonmodal .modal-body-content").text("Értékelésed sikeresen elküldted.");
        $("#commonmodal").modal("show");
    }

    const handleFeedbackChange = (e) => {
        if (e.target.value.length <= 500) setReview(e.target.value);
    };

    function openOenLoginModal() {
        closeModal();
        $("#loginModal").modal();
    }

    useEffect(() => {
        fetch(`${apiURL()}/user-review/${props.bookid}`)
            .then((res) => res.json())
            .then((res) => {
                if (!res) return;
                setRating(res.rate);
                setReview(res.review || "");
            });
    }, [props]);

    return (
        <>
            <div className="ratingModal__content hidden" id="ratingModal">
                <div className="ratingModal__close d-flex justify-content-end">
                    <img
                        src="../../../images/icon/close-modal.svg"
                        alt="close"
                        onClick={closeModal}
                    />
                </div>
                <div className="d-flex justify-content-between align-items-center">
                    <span className="ratingModal__heading">
                        {props.login
                            ? "Mit gondolsz a könyvről?"
                            : "Jelentkezz be az értékeléshez!"}
                    </span>
                    <div className="ratingModal__scoreBox">
                        <div className="ratingModal__scoreBox__score">
                            <img src="../../../images/icon/new-star-100.svg" alt="star" />
                            {Number(props.totalRating).toFixed(1)}
                        </div>
                        <span className="ratingModal__scoreBox__title">
                            Átlagos vásárlói értékelés
                        </span>
                    </div>
                </div>
                {props.login ? (
                    <>
                        <div className="ratingModal__rating">
                            <div className="ratingModal__ratingText">
                                Értékelésed:{" "}
                                <span className="ratingModal__ratingText__score">{rating}</span>
                            </div>
                            <SetRatingStars initialRate={rating} getRate={setRating} />
                        </div>
                        <div>
                            <textarea
                                cols="30"
                                rows="10"
                                onChange={handleFeedbackChange}
                                value={review}
                                className="ratingModal__textArea"
                            />
                            <div className="ratingModal__textArea__counter">
                                {review.length}/500
                            </div>
                        </div>
                        <p className="info-text">
                            Az értékelésedet először az adminisztrátornak kell engedélyeznie, hogy
                            megjelenjen.
                        </p>
                        <div className="text-center">
                            <button
                                className="btn new-product-action-btn ratingModal__btn"
                                onMouseDown={handleSave}
                            >
                                Értékelés elküldése
                            </button>
                        </div>
                    </>
                ) : (
                    <div className="ratingModal__captions">
                        <button
                            className="btn new-product-action-btn ratingModal__btn"
                            onMouseDown={openOenLoginModal}
                        >
                            Bejelentkezés
                        </button>
                        <button
                            className="ratingModal__btnRegister ratingModal__btn"
                            onMouseDown={openOenLoginModal}
                        >
                            Regisztráció
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};

export default RatingBook;
